var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-score-main"},[(_vm.useTemplateOne)?_c('TemplateOne',{attrs:{"quiz":_vm.quiz}}):_vm._e(),(_vm.useTemplateTwo)?_c('TemplateTwo',{attrs:{"quiz":_vm.quiz}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }